import { render, staticRenderFns } from "./modal-intention.vue?vue&type=template&id=07398584&scoped=true"
import script from "./modal-intention.vue?vue&type=script&lang=js"
export * from "./modal-intention.vue?vue&type=script&lang=js"
import style0 from "./modal-intention.vue?vue&type=style&index=0&id=07398584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07398584",
  null
  
)

export default component.exports